import { Button, FormControl, FormHelperText, FormLabel, Input, Stack, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';

interface ForgotFormFormProps {
  onSubmit: (username: string) => void;
}

interface ForgotFormValues {
  username: string;
}

export function ForgotForm(props: ForgotFormFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotFormValues>();

  const onSubmit = (data: ForgotFormValues) => {
    props.onSubmit(data.username);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={2} sx={{ mb: 2 }}>
        <Typography variant="body2" textAlign="center">
          Zadajte svoj e-mail, na ktorý vám pošleme odkaz na obnovenie hesla.
        </Typography>
        <FormControl required fullWidth error={!!errors.username}>
          <FormLabel>E-mail</FormLabel>
          <Input autoComplete="username" {...register('username', { required: 'E-mail je povinný' })} />
          {errors.username && <FormHelperText>{errors.username.message}</FormHelperText>}
        </FormControl>
      </Stack>
      <Button type="submit" fullWidth variant="contained">
        Odoslať e-mail na obnovenie hesla
      </Button>
    </form>
  );
}
